import systemStatusApi from '@/api/systems'
import api from '@/api'

function sortByName(a, b) {
  if (a.name < b.name) {
    return -1
  }
  if (a.name > b.name) {
    return 1
  }
  return 0
}

function sortById(a, b) {
  return a.id - b.id
}

export default {
  namespaced: true,

  state: {
    collection: [],
    externalSystems: [],
    headerSystems: [],
    system: {},
    externalSystem: {},
    status: {
      update_date: null,
      end_date: null,
      title: null,
      description: null
    },
    updates: [],
    systemUpdates: [],
    loading: false,
    filters: {
      searchQuery: '',
      size: 10
    },
    sortBy: {
      field: 'name.raw',
      direction: 'asc'
    },
    pagination: {
      total: 20,
      per_page: 20,
      current_page: 1,
      last_page: 1,
      from: 1,
      to: 20
    }
  },

  getters: {
    // order systems by state and then by name
    orderedSystems: state => {
      const systems = state.collection
      if (!systems || systems.length < 1) {
        return []
      }
      const critical = systems
        .filter(system => system.value === 0)
        .sort(sortByName)
      const warning = systems
        .filter(system => system.value === 2)
        .sort(sortByName)
      const working = systems
        .filter(system => system.value === 1)
        .sort(sortByName)
      return [...critical, ...warning, ...working]
    },
    // For the sidebar we need to add extra bits for the side menu to work
    navigationSystems: state => {
      const systems = state.collection
      if (!systems || systems.length < 1) {
        return []
      }
      return state.collection
        .filter(system => system.value !== 1)
        .map(system => ({
          ...system,
          isOpen: false,
          children: [
            {
              to: '/system-status',
              text: 'Loading...',
              icon: 'test',
              isOpen: false
            }
          ]
        }))
        .sort((a, b) => a.value - b.value)
    },

    headerLinks: state =>
      state.externalSystems.filter(system => system.homepage === 1)
  },

  mutations: {
    setCollection(state, collection) {
      state.collection = collection
    },
    setSearchQuery(state, val) {
      state.filters.searchQuery = val
    },
    setSortBy(state, { direction, field }) {
      // set direction to 'asc' if not set
      const sortDir = direction || 'asc'
      const sortField = field.replace('_title', '_name')
      state.sortBy.direction = sortDir
      state.sortBy.field = ['created_time', 'end_date'].includes(sortField)
        ? sortField
        : sortField.split('_')[1] // hack
    },
    SET_SYSTEM(state, payload) {
      state.system = payload
    },
    SET_STATUS(state, payload) {
      state.status = payload
    },
    SET_EXTERNAL_SYSTEM(state, payload) {
      state.externalSystem = payload
    },
    SET_UPDATE_LIST(state, payload) {
      state.updates = payload
    },
    SET_EXTERNAL_SYSTEMS(state, payload) {
      state.externalSystems = payload
    },
    SET_HEADER_SYSTEMS(state, payload) {
      state.headerSystems = payload
    },
    SET_SYSTEM_UPDATE(state, payload) {
      const { id, description } = payload
      if (id && description) {
        state.systemUpdates[id] = description
      }
    },
    SET_FILTER_TOTAL(state, total) {
      state.pagination.total = total;
      state.pagination.last_page = Math.ceil(total / state.pagination.per_page);
    },
    SET_CURRENT_PAGE(state, page) {
      state.pagination.current_page = page;
    },
    SET_RESULT_COUNT(state, number) {
      state.filters.size = number;
      state.pagination.per_page = number;
      state.pagination.total = number;
      state.pagination.to = number;
    },
  },

  actions: {
    async resetSearch(context) {
      await context.commit('setSearchQuery', '')
      return Promise.resolve('reset')
    },
    async list({ commit, state, dispatch }, options = {}) {
      let tabFilter
      let forceUpdate = false

      let size = state.pagination.per_page;
      const page = options.page ? options.page : 1;
      let from = size * page - size;

      if (!from) {
        from = 0
      }

      if (options && options.tabFilter) {
        tabFilter = options.tabFilter
      }

      if (options && options.forceUpdate) {
        forceUpdate = options.forceUpdate
      }
      
      // if we have a search query, we want to remove size restrictions
      if (state.filters.searchQuery) {
        size = 10000;
        forceUpdate = true;
      }
      
      console.log("TCL: list -> options", options)
      console.log("TCL: list -> forceUpdate", forceUpdate)
      let endpoint = '/system/statuses/flat'
      let key = 'mft_systems_list'
      if (tabFilter === 'following') {
        endpoint = '/system/statuses/favourites'
        key = 'mft_systems_list_favourites'
      }
      // only update every 5 minutes

      const localSystems = localStorage.getItem(key)
      const timeDiff = 60000 * 5
      let payload
      if (
        !localSystems ||
        JSON.parse(localSystems).timestamp < new Date().getTime() - timeDiff ||
        forceUpdate
      ) {
        let response
        // if (loading) {
        // commit("setCollection", []);
        // }
        const filter = {
          sort: [
          {
              '_script': {
                'type': 'number',
                  'script': {
                    'lang': 'painless',
                    'inline': 'if (doc[\'value\'].value == \'0\') { return 0; } else if (doc[\'value\'].value == \'2\') {return 1;} else {return 2;}'
                  },
                'order': 'asc'
              }
            },
            {
              [state.sortBy.field]: {
                order: state.sortBy.direction
              }
            }
          ],
          size,
          from,
          query: {
            bool: {
              should: [
                {
                  match: {
                    name: {
                      query: state.filters.searchQuery,
                      operator: 'and',
                      zero_terms_query: 'all',
                      fuzziness: 'AUTO'
                    }
                  }
                },
                {
                  match_phrase_prefix: {
                    name: {
                      query: state.filters.searchQuery,
                      slop: 50
                    }
                  }
                }
              ]
            }
          }
        }

        try {
          response = await api().put(endpoint, { filter })
          payload = {
            systems: response.data.data.status,
            timestamp: new Date().getTime()
          }
          commit('SET_FILTER_TOTAL', response.data.meta.filter_total)
          commit('SET_CURRENT_PAGE', page)

          localStorage.setItem(key, JSON.stringify(payload))
        } catch (err) {
          localStorage.setItem(key, JSON.stringify([]))
          return Promise.reject(err)
        }
      } else {
        payload = JSON.parse(localSystems)

        /**
         * Do we have a filter or sort?
         */
        if (state.filters.searchQuery || state.sortBy) {
          let filteredSystems = payload.systems
          let sortedSystems

          if (state.filters.searchQuery) {
            filteredSystems = filteredSystems.filter(system =>
              system.name
                .toLowerCase()
                .includes(state.filters.searchQuery.toLowerCase())
            )
          }

          if (state.sortBy) {
            // need to order the results
          }
          commit('setCollection', filteredSystems)
          return Promise.resolve(filteredSystems)
        }
      }
      commit('setCollection', payload.systems)
      return Promise.resolve(payload.systems)
    },

    async add({ dispatch }, payload) {
      let response

      try {
        response = await api().post('/system/status', { status: payload })
        // make the system online
        await dispatch('markAsOnline', response.data.data.status[0].id)
        return Promise.resolve(response)
      } catch (err) {
        return Promise.reject(err)
      }
    },

    async edit(context, { name, id }) {
      let response

      try {
        response = await api().post(`/system/status/${id}`, {
          status: { name }
        })
        return Promise.resolve(response)
      } catch (err) {
        return Promise.reject(err)
      }
    },

    async read({ commit }, id) {
      let response

      try {
        response = await api().get(`/system/status/${id}`)
        commit('SET_SYSTEM', response.data.data.status[0])
        return Promise.resolve(response.data.data.status[0])
      } catch (err) {
        return Promise.reject(err)
      }
    },

    async delete({ dispatch }, id) {
      let response

      try {
        response = await api().delete(`/system/status/${id}`)
        dispatch('list')
        dispatch(
          'notifications/create',
          {
            body: 'The system status  was deleted',
            type: 'success'
          },
          { root: true }
        )
        return Promise.resolve(response)
      } catch (err) {
        return Promise.reject(err)
      }
    },

    async readExternal({ commit }, id) {
      let response

      try {
        response = await api().get(`/system/external/${id}`)
        commit('SET_EXTERNAL_SYSTEM', response.data.data.external[0])
        return Promise.resolve(response.data.data.external[0])
      } catch (err) {
        return Promise.reject(err)
      }
    },

    favourite({ dispatch }, systemStatusId) {
      localStorage.removeItem('mft_systems_list')
      localStorage.removeItem('mft_systems_list_favourites')
      systemStatusApi.favourite(systemStatusId).then(system => {
        dispatch('list')

        dispatch(
          'notifications/create',
          {
            body: `You're now following <strong>${system.name}</strong>`,
            type: 'success'
          },
          { root: true }
        )
      })
    },
    unfavourite({ dispatch }, systemStatusId) {
      localStorage.removeItem('mft_systems_list')
      localStorage.removeItem('mft_systems_list_favourites')
      systemStatusApi.unfavourite(systemStatusId).then(system => {
        dispatch('list', { forceUpdate: true })

        dispatch(
          'notifications/create',
          {
            body: `You are no longer following <strong>${system.name}</strong>`,
            type: 'success'
          },
          { root: true }
        )
      })
    },

    async markAsOnline(context, id) {
      let response

      try {
        response = await api().post(`/system/status/${id}/online`)
        return Promise.resolve(response)
      } catch (err) {
        return Promise.reject(err)
      }
    },

    async markAsOffline(context, id) {
      let response

      try {
        response = await api().post(`/system/status/${id}/offline`)
        return Promise.resolve(response)
      } catch (err) {
        return Promise.reject(err)
      }
    },

    async markAsIssue(context, id) {
      let response

      try {
        response = await api().post(`/system/status/${id}/issue`)
        return Promise.resolve(response)
      } catch (err) {
        return Promise.reject(err)
      }
    },

    /**
     * Down here relates to updates
     * TODO: Should they be in their own store?
     */

    async getCurrentStatus(context, id) {
      let response

      try {
        response = await api().get(`/system/status/${id}/currentUpdate`)
        if (response.data.data.update[0].description) {
          context.commit('SET_SYSTEM_UPDATE', {
            id,
            description: response.data.data.update[0].description
          })
          return Promise.resolve(response)
        }
      } catch (err) {
        return Promise.reject(err)
      }
    },

    async getUpdates({ commit }, id) {
      let response
      commit('SET_UPDATE_LIST', [])
      try {
        response = await api().get(`/system/status/${id}/updates`)
        commit('SET_UPDATE_LIST', response.data.data.update)
        return Promise.resolve(response)
      } catch (err) {
        return Promise.reject(err)
      }
    },

    async update(context, { id, payload }) {
      let response

      try {
        response = await api().post(`/system/status/${id}/update`, {
          update: payload
        })
        return Promise.resolve(response)
      } catch (err) {
        return Promise.reject(err)
      }
    },

    // external systems
    // this one doesn't need to cache
    async listExternal({ commit, state }, params = {}) {
      let response
      const endpoint = '/system/externals'
      const payload = {}
      const size = state.pagination.per_page;
      const page = params.page ? params.page : 1;
      let from = size * page - size;

      if (!from) {
        from = 0;
      }

      const filter = {
        sort: [
          {
            [state.sortBy.field]: {
              order: state.sortBy.direction
            }
          }
        ],
        size,
        from,
        query: {
          bool: {
            should: [
              {
                match: {
                  name: {
                    query: state.filters.searchQuery,
                    operator: 'and',
                    zero_terms_query: 'all',
                    fuzziness: 'AUTO'
                  }
                }
              },
              {
                match_phrase_prefix: {
                  name: {
                    query: state.filters.searchQuery,
                    slop: 50
                  }
                }
              }
            ]
          }
        }
      }

      try {
        response = await api().put(endpoint, { filter })
        commit('SET_EXTERNAL_SYSTEMS', response.data.data.external)
        commit('SET_FILTER_TOTAL', response.data.meta.filter_total);
        commit('SET_CURRENT_PAGE', page);
        return Promise.resolve(response.data.data.external)
      } catch (err) {
        if (err.response.data.data.length < 1) {
          commit('SET_EXTERNAL_SYSTEMS', [])
          return Promise.resolve([])
        }
        return Promise.reject(err)
      }
    },

    // get all the external systems for the header
    async getExternalHeaderLinks({ state }, params = {}) {
      let response
      let payload

      const localList = localStorage.getItem('mft_systems_listExternal')
      const timeDiff = 6000 * 5

      const filter = {
        sort: [
          {
            [state.sortBy.field]: {
              order: state.sortBy.direction
            }
          }
        ],
        size: 10,
        from: 0,
        query: {
          bool: {
            must: {
              term: {
                homepage: true
              }
            }
          }
        }
      }

      if (
        !localList ||
        params.forceUpdate ||
        JSON.parse(localList).timestamp < new Date().getTime() - timeDiff
      ) {
        try {
          response = await api().put('/system/externals/flat', { filter })
          payload = {
            systems: response.data.data.external,
            timestamp: new Date().getTime()
          }
          localStorage.setItem(
            'mft_systems_listExternal',
            JSON.stringify(payload)
          )
        } catch (err) {
          if (err.response.data.data.length < 1) {
            payload = {
              systems: [],
              timestamp: new Date().getTime()
            }
            localStorage.setItem(
              'mft_systems_listExternal',
              JSON.stringify(payload)
            )
          } else {
            localStorage.setItem(
              'mft_systems_listExternal',
              JSON.stringify([])
            )
            return Promise.reject(err)
          }
        }
      } else {
        payload = JSON.parse(localList)
      }

      return Promise.resolve(payload.systems)
    },
    async addExternal({ dispatch }, payload) {
      let response

      try {
        response = await api().post('/system/external', { external: payload })
        dispatch('listExternal')

        return Promise.resolve(response)
      } catch (err) {
        return Promise.reject(err)
      }
    },
    async editExternal({ dispatch }, { id, external }) {
      let response

      try {
        response = await api().post(`/system/external/${id}`, { external })
        // make the system online
        dispatch('listExternal')

        return Promise.resolve(response)
      } catch (err) {
        return Promise.reject(err)
      }
    },

    resetExternal({ commit }) {
      commit('SET_EXTERNAL_SYSTEM', {})
    },
    async deleteExternal({ dispatch }, systemId) {
      let response
      try {
        response = await api()
          .delete(`/system/external/${systemId}`)
          .then(resp => {
            dispatch('listExternal')
            dispatch(
              'notifications/create',
              {
                body: `The external status <strong>${resp.name}</strong> was deleted`,
                type: 'success'
              },
              { root: true }
            )
            response = resp.data.data.system
          })
        return Promise.resolve(response)
      } catch (err) {
        return Promise.reject(err)
      }
    },

    async getLinksforStrip({ commit }) {
      let response
      const filter = {
        query: {
          bool: {
            must: {
              term: {
                homepage: true
              }
            }
          }
        }
      }

      try {
        response = await api().post('/system/externals', { filter })
        commit('SET_HEADER_SYSTEMS', response.data.data.external)
        return Promise.resolve(response.data.data.external)
      } catch (err) {
        return Promise.reject(err)
      }
    }
  }
}
